export const ADVANCED_FILTER_DEFAULT_OPTION_VALUE = 'ALL';
export const ADVANCED_FILTER_DEFAULT_OPTION_STAT_KEY = 'total';

export const ADVANCED_FILTER_DEFAULT_OPTION = {
  label: 'All',
  value: ADVANCED_FILTER_DEFAULT_OPTION_VALUE,
  statKey: ADVANCED_FILTER_DEFAULT_OPTION_STAT_KEY
};